export const ConfigurationCreateController = ($scope,
                                              $mdDialog,
                                              callback,
                                              userCompany,
                                              sourceConfig) => {
    "ngInject";

    $scope.callback = callback;
    $scope.sourceConfig = sourceConfig;
    $scope.configuration = {
        company: $scope.sourceConfig ? $scope.sourceConfig.company : userCompany.url,
        name: $scope.sourceConfig ? `${$scope.sourceConfig.name} (copy)` : "",
        enableWizard: $scope.sourceConfig ? !$scope.sourceConfig.json.admin.isAdvanced : false
    };

    // if json provided than clone configuration
    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);
    $scope.selectedCompany = userCompany ? [userCompany] : [];

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        callback($scope.configuration);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.configuration.company && $scope.configuration.name && $scope.configuration.name.length >= 3) {
                $scope.create();
            }
        }
    };
};



// WEBPACK FOOTER //
// ./sources/components/configurations/configuration-create/configuration-create.js